import React from 'react'
import { Segmented } from 'antd'
import { useTranslation } from 'react-i18next'

interface DefaultToggleFieldProps {
  value?: boolean
  onChange?: (value: boolean) => void
  disabled?: boolean
  loading?: boolean
}

const DefaultToggleField: React.FC<DefaultToggleFieldProps> = ({ value, onChange, disabled, loading }) => {
  const { t } = useTranslation()

  return (
    <Segmented
      disabled={disabled}
      block
      value={value ? 'yes' : 'no'}
      options={[
        { label: t('global:yes'), value: 'yes' },
        { label: t('global:no'), value: 'no' }
      ]}
      onChange={newValue => {
        if (loading) return
        onChange?.(newValue === 'yes')
      }}
    />
  )
}

export default DefaultToggleField
